import { render } from "./HeroiconsSolidClipboard.vue?vue&type=template&id=d494ecb2"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidClipboard.vue"]])

export default __exports__